import React from 'react';

const questions = [
  'Do you have more than two business entities?',
  'Have you maximized R&D or energy credits in the last 3 years?',
  'Do you have a MERP or reimbursement plan in place?',
  'Are depreciation schedules aligned across your portfolio?'
];

export default function TaxScorecard() {
  return (
    <div className="bg-gray-warm min-h-screen py-20 px-6">
      <div className="max-w-4xl mx-auto space-y-8">
        <header className="space-y-3 text-center">
          <p className="text-sm uppercase tracking-[0.4em] text-gray-500">Tax Scorecard</p>
          <h1 className="text-4xl font-bold text-charcoal">Score your readiness</h1>
          <p className="text-gray-600">Answer four questions and see where a strategy assessment can move the needle.</p>
        </header>

        <div className="space-y-4">
          {questions.map((question) => (
            <div key={question} className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
              <p className="text-lg font-semibold text-charcoal">{question}</p>
              <div className="mt-3 flex items-center gap-3 text-sm text-gray-500">
                <button className="rounded-full border border-primary/20 px-4 py-2 text-primary">Yes</button>
                <button className="rounded-full border border-gray-300 px-4 py-2">No</button>
                <span className="text-xs uppercase tracking-[0.4em]">Self-score</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-500">Score below expectations?</p>
          <a href="/free-assessment" className="mt-3 inline-flex items-center justify-center rounded-full bg-primary px-6 py-3 text-sm font-semibold text-white shadow-lg">
            Book a strategy call
          </a>
        </div>
      </div>
    </div>
  );
}
